<template>
  <div>
    <slot></slot>
    <checkbox v-if="showSwitch" label="Family" class="circle" :value="true" v-model="status"></checkbox>
    <horizontal-scroll v-show="status" class="margin-top-x2">
      <template v-if="entitlementType">
        <div
          :key="n.id"
          v-for="(n,i) in nominees"
          :class="[{disabled:remain[i]<=0}]"
          :set="remain[i] = getEntitlementRemain(n.entitlement,entitlementType)"
          class="nominee-checkbox-outline margin-right-x2 padding"
        >
          <checkbox
            :disabled="remain[i]<=0"
            :name="`members${i}`"
            :value="n.uuid"
            v-model="members"
          >
            <b>{{getFullName(n)}}</b>
            <div v-if="n.entitlement">Entitlements Left :{{remain[i]}}</div>
          </checkbox>
        </div>
      </template>
      <template v-else>
        <div
          v-for="(n,i) in nominees"
          :key="n.id"
          class="nominee-checkbox-outline margin-right-x2 padding-x2"
        >
          <checkbox :class="optionStyle" :name="`members${i}`" :value="n.uuid" v-model="members">
            <b>{{getFullName(n)}}</b>
          </checkbox>
        </div>
      </template>
    </horizontal-scroll>
  </div>
</template>
<script>
import { entitlementTypes } from "../../core/enum";
import { getFullName } from "../../core/staff-helper";
import HorizontalScroll from "../../components/layout/HorizontalScroll";
export default {
  inheritAttrs: false,
  name: "family-slider",
  components: {
    HorizontalScroll
  },
  props: {
    showSwitch: {
      type: Boolean,
      default: true
    },
    switch: {
      type: Boolean,
      default: true
    },
    nominees: {
      type: Array,
      default: () => []
    },
    optionStyle: {
      default: "circle"
    },
    value: {
      type: Array,
      default: () => []
    },
    entitlementType: {
      type: Number
    }
  },
  data() {
    return {
      remain: [],
      members: [],
      status: this.switch
    };
  },
  methods: {
    getEntitlementRemain(e, type) {
      if (e && type) {
        if (type === entitlementTypes.confirmed) {
          return e.confirmed - e.confirmedUsed;
        } else if (type === entitlementTypes.standby) {
          return e.standby - e.standbyUsed;
        }
      }
      return 0;
    },
    getFullName(usr) {
      return getFullName(usr);
    }
  },
  watch: {
    status(val) {
      this.$emit("update", val);
    },
    members(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    entitlementTypes() {
      return entitlementTypes;
    }
  },
  created() {
    this.members = this.value;
  },
  updated() {
    this.members = this.value;
    this.status = this.switch;
  }
};
</script>